import React from "react";
import { useTable, usePagination, useSortBy, useFilters } from "react-table";

import loader from "../../../../images/ajax-loader.gif";
import TablePagination from "./TablePagination";

function CrudTable({
  loading,
  data,
  columns,
  onEdit,
  onRemove,
  onDetails,
  idField,
  showDetails,
  showEdit = true,
  showRemove = true,
}) {
  const ActionCell = ({ id }) => (
    <div>
      {showEdit && (
        <>
          <button
            className="btn btn-primary btn-sm mr-2"
            onClick={() => onEdit(id)}
          >
            Edit
          </button>
        </>
      )}
      {showRemove && (
        <button
          className="btn btn-danger btn-sm mr-2"
          onClick={() => onRemove(id)}
        >
          Remove
        </button>
      )}
      {showDetails && (
        <button
          className="btn btn-primary btn-sm mr-2"
          onClick={() => onDetails(id)}
        >
          View Details
        </button>
      )}
    </div>
  );

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,

    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;

  return (
    <div>
      {loading ? (
        <div className="d-flex justify-content-center">
          <img src={loader} />
        </div>
      ) : data && data.length > 0 ? (
        <div>
          <table {...getTableProps()} className="table table-sm table-bordered">
            <thead className="bg-primary text-light">
              {headerGroups.map((headerGroup, i) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                  {headerGroup.headers.map((column, i) => (
                    <th key={i}>
                      <div
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : ""}
                        </span>
                      </div>
                      {column.canFilter && (
                        <div className="d-flex justify-content-center mt-2">
                          {column.render("Filter")}
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={i}>
                    {row.cells.map((cell, key) => {
                      const id = row.original[idField]?.toString() || "";
                      return (
                        <td {...cell.getCellProps()} key={key}>
                          {cell.column.id === "Actions" ? (
                            <ActionCell id={id} />
                          ) : (
                            cell.value || ""
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <TablePagination
            pageIndex={pageIndex}
            pageSize={pageSize}
            pageCount={pageCount}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            pageOptions={pageOptions}
            gotoPage={gotoPage}
            nextPage={nextPage}
            previousPage={previousPage}
            setPageSize={setPageSize}
          />
        </div>
      ) : (
        <div>No data found</div>
      )}
    </div>
  );
}

export default CrudTable;
